import React from 'react';
import { motion } from 'framer-motion';
import { SectionEyebrow } from './SectionEyebrow';
import { CTAButton } from './CTAButton';
export function SobrePaola() {
  return <section className="py-24 md:py-32 px-6 bg-card" data-id="element-249">
      <div className="container max-w-[1000px] mx-auto" data-id="element-250">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center" data-id="element-251">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-252">
            <div className="rounded-2xl overflow-hidden shadow-soft relative" data-id="element-253">
              <img src="https://cdn.magicpatterns.com/uploads/22mDh6LQEczAscrxi2KaJW/BE22049D-3AC8-40A4-985F-FFD76A0932A4.png" alt="Paola Rojas" className="w-full h-[400px] md:h-[600px] object-cover object-center" data-id="element-254" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" data-id="element-255"></div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex flex-col justify-center" data-id="element-256">
            <SectionEyebrow text="Hola, soy Paola" className="mb-6" data-id="element-257" />

            <h2 className="text-4xl md:text-5xl text-foreground mb-8 leading-tight" data-id="element-258">
              Dejé de buscar afuera lo que ya estaba{' '}
              <span className="italic text-muted-foreground" data-id="element-259">en mí.</span>
            </h2>

            <div className="space-y-6 text-lg text-muted-foreground font-light leading-relaxed" data-id="element-260">
              <p data-id="element-261">
                Esta experiencia nació de mi proceso de reconstrucción. Hubo una
                versión de mí que se perdió tratando de ser amada en el lugar
                incorrecto. Que se conformó. Que se olvidó de su propio valor y
                de lo que realmente merecía.
              </p>
              <p data-id="element-262">
                Y un día, en silencio, decidí volver a mí. Decidí reconstruir mi
                identidad, sanar mis heridas y reconectar con Dios para entender
                quién era yo realmente.
              </p>
              <p data-id="element-263">
                Este libro es la guía que hubiera querido encontrar en ese
                momento, escrita con todo lo que aprendí en el proceso de
                elegirme, de elevar mis estándares y de abrazar mi feminidad.
              </p>
            </div>

            <div className="mt-10" data-id="element-264">
              <p className="font-serif text-2xl text-foreground italic" data-id="element-265">
                Con amor, Paola
              </p>
            </div>

            <div className="mt-10" data-id="element-266">
              <CTAButton text="Quiero empezar mi proceso" data-id="element-267" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}